module.exports = __webpack_public_path__ + "static/media/group-people-community-Inactive.e098c173.svg";